import { defineComponent as _defineComponent } from 'vue'
import { BIcon } from "bootstrap-vue";
import { marked } from "marked";
import { computed, ref } from "vue";
import Feedback from "./Feedback.vue";
import Text2Speech from "./Text2Speech.vue";
import WaitingDots from "./WaitingDots.vue";
import { useProtocolStore } from "./store/protocol-store";
import { Exchange } from "./types/Exchange";
import { FeedbackEvent } from "./types/FeedbackEvent";


export default /*#__PURE__*/_defineComponent({
  __name: 'Exchange',
  props: {
    exchange: null,
    streaming: { type: Boolean }
  },
  emits: ["feedback"],
  setup(__props: any, { emit }: { emit: ({
  (eventName: "feedback", event: FeedbackEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  exchange: Exchange;
  streaming?: boolean;
};

const protocolStore = useProtocolStore();





const handleFeedback = ({ questionUuid, feedbackType, feedbackText }: FeedbackEvent) => {
  emit("feedback", { questionUuid, feedbackType, feedbackText });
};

const shouldShowDetailed = ref(false);

const detailedRequested = ref(false);

const toggleDetailed = () => {
  shouldShowDetailed.value = !shouldShowDetailed.value;

  if (
    shouldShowDetailed.value &&
    !detailedRequested.value &&
    props.exchange.questionUuid &&
    (!props.exchange.detailedResult || props.exchange.detailedResult.length <= 1)
  ) {
    detailedRequested.value = true;
    protocolStore.getDetailedResponse(props.exchange.questionUuid, props.exchange.question || "");
  }
};

const stripMarkdownCodeBlock = (text: string): string => {
  // Remove leading ```markdown or ``` and trailing ```
  return text.replace(/^```(?:markdown)?\n?/, "").replace(/```[\s\n]*$/, ""); // Remove trailing backticks and any whitespace/newlines
};

const markdownToDisplay = computed(() => {
  let raw = shouldShowDetailed.value ? props.exchange.detailedResult ?? "" : props.exchange.summarizedResult ?? "";
  return stripMarkdownCodeBlock(raw);
});

const renderedMarkdown = computed(() => {
  return marked(markdownToDisplay.value);
});

const shouldShowFeedback = () => {
  return protocolStore.shouldShowFeedback.value && !props.streaming;
};

const isDetailedLoading = computed(() => !!props.exchange.detailedLoading);

const uniquePageLinks = computed(() => {
  return Array.from(new Set(props.exchange.pageLinks));
});

const generatingLabel = computed(() => {
  return props.streaming && protocolStore.shouldShowAnswer.value && !props.exchange.question
    ? "Generating summary"
    : undefined;
});

const showWaitingDots = computed(() => {
  if (props.streaming) {
    if (protocolStore.shouldShowAnswer.value) {
      return !markdownToDisplay.value.length;
    } else {
      return !props.exchange.pageLinks?.length;
    }
  }

  if (isDetailedLoading.value && shouldShowDetailed.value) {
    return !markdownToDisplay.value.length;
  }

  return false;
});

return { __sfc: true,protocolStore, props, emit, handleFeedback, shouldShowDetailed, detailedRequested, toggleDetailed, stripMarkdownCodeBlock, markdownToDisplay, renderedMarkdown, shouldShowFeedback, isDetailedLoading, uniquePageLinks, generatingLabel, showWaitingDots, BIcon, Feedback, Text2Speech, WaitingDots }
}

})